import type { ApiResponse, PaginationQuery, AlbumDto } from '@lyricshub/shared';
import { api } from './api';

export interface AlbumDetailDto extends AlbumDto {
  artist: { id: string; name: string; slug: string };
  genre: { id: string; name: string; slug: string } | null;
  songCount: number;
}

export const albumsService = {
  async getAlbums(params?: PaginationQuery): Promise<ApiResponse<AlbumDto[]>> {
    const response = await api.get('/albums', { params });
    return response.data;
  },

  async getAlbumBySlug(slug: string): Promise<ApiResponse<AlbumDetailDto>> {
    const response = await api.get(`/albums/${slug}`);
    return response.data;
  },
};
